import { ReactElement } from 'react'
import { Form } from '@ui/forms'
import CLTLayerFormFields from './CLTLayerFormFields'
import { cltFormSchema } from './schema'
import { layerToFormState } from './utils'

const CLTLayerForm = ({ id, onSubmit, defaultValues }: LayerFormProps): ReactElement => {
  return (
    <Form
      id={id}
      validationSchema={cltFormSchema}
      defaultValues={
        layerToFormState(defaultValues as CLTAssemblyLayer) || cltFormSchema.getDefault()
      }
      onSubmit={values => onSubmit(values.layer)}
    >
      <CLTLayerFormFields />
    </Form>
  )
}

export default CLTLayerForm
